import {getFileUrl} from "@/api/file";

export function formatDataFromSever(severData) {
    // const {toUIds,ccUIds} = severData;//timeSeg, validateS, validateE, 
    // console.log('a',severData,toUIds,ccUIds)
    var obj=[];
    severData.forEach(element => {
        const {toUIds,ccUIds,sampleLog:sample,sample21VLog} = element;
        // console.log('sampleLog',sampleLog);
        element.toUIdsArray=changetoUIdsStrtoArray({toUIds}).toUIdsArray;
        element.ccUIdsArray=changeccUIdsStrtoArray({ccUIds}).ccUIdsArray;
        element.sampleLog= getSampleArrayFromSever({sample}),
        element.sample21VLog= getSampleArrayFromSever({sample:sample21VLog}),
        // console.log('sampleLog',element.sample21VLog)//sample,element.sampleLog);
        obj.push(element);
    });
    // console.log('obj',obj)
    return {
        obj
        // ...severData,
        // ...changetoUIdsStrtoArray({toUIds}),
        // ...changeccUIdsStrtoArray({ccUIds}),
        // ...createStationXMLArrayFromSever({stationXml}),
    };
}

export function changetoUIdsStrtoArray({toUIds}){
    var userArray=[];
    if (toUIds){
        var ids = toUIds.split(',');    
        ids.forEach(element => {
            if (element){           
                userArray.push(element)
            }
        });
    }
    return {toUIdsArray: userArray};
    // return userArray;
}
export function changeccUIdsStrtoArray({ccUIds}){
    var userArray=[];
    if (ccUIds){
        var ids = ccUIds.split(',');
        
        ids.forEach(element => {
            if (element){            
                userArray.push(element)
            }
        });
    }
    return {ccUIdsArray: userArray};
    // return userArray;
}

export function formatMainDataFromSever(severData) {
    const {sheetTypeIds,sample} = severData;//timeSeg, validateS, validateE, 
    // var aa = changeSheetTypeIdstoArray({sheetTypeIds});
    // console.log('sheetTypeIds',sheetTypeIds)
    return {
        ...severData,
        ...changeSheetTypeIdstoArray({sheetTypeIds}),
        sample: getSampleArrayFromSever({ sample }),
        // ...createStationXMLArrayFromSever({stationXml}),
    };
}

export function changeSheetTypeIdstoArray({sheetTypeIds}){
    if (!sheetTypeIds) return {sheetTypeIds: []};
    var ids = sheetTypeIds.split(',');
    var sheetTypeIds=[];
    ids.forEach(element => {
        if (element){
            sheetTypeIds.push(element);
        }
    });
    // console.log('sheetTypeIds',sheetTypeIds)
    return {sheetTypeIds: sheetTypeIds};
}

export function changeStrtoArray({userIds}){
    var userArray=[];
    var ids = userIds.split(',');
    ids.forEach(element => {
        if (element){
            var subArr=[];
            subArr.push(element.split('-')[0]);
            subArr.push(element.split('-')[1]);
            userArray.push(subArr)
        }
    });
    return {userArray: userArray};
    // return userArray;
}

export function changeStationtoArray({stationIdFull}){
    var stationArray=[];
    // var ids = stationIdFull.split(',');
    // ids.forEach(element => {
    //     if (element){
            var subArr=[];
            subArr.push(stationIdFull.split('-')[0]);
            subArr.push(stationIdFull.split('-')[1]);
            stationArray.push(subArr)
    //     }
    // });
    return {stationArray: stationArray[0]};
    // return userArray;
}

export function changeMediaTypetoArray({mediaTypes}){
    var mtArray=[];
    var ids = mediaTypes.split(',');
    ids.forEach(element => {
        if (element){
            mtArray.push(element);
        }
    });
    console.log('mtArray',mtArray)
    return {mtArray: mtArray};
}


export function createStationXMLArrayFromSever({stationXml}) {
    if (stationXml) {
        try {
            // console.log('cc:',stationXml);
            const xmlManager = new XMLManager(`<Parent>${stationXml}</Parent>`);
            const shareArray = xmlManager.getXMLNodeValueByAttributeName({tagName: 'Detail'}).map(item => {
                const {stationIdFull,mediaTypes} = item;
                return {
                    ...item, 
                    ...changeMediaTypetoArray({mediaTypes}),
                    ...changeStationtoArray({stationIdFull})
                }
            });
            console.warn('createStationXMLArrayFromSever', shareArray);
            return {stationXmlArray: shareArray?.length ? shareArray : getDefaultStationXmlArray()};
        } catch (e) {
            console.error(e);
        }
    }
    return {stationXmlArray: getDefaultStationXmlArray()};
}

export function getDefaultStationXmlArray() {
    var obj = [{
        detailId: '新增' + Date.now(),
        stationId:'',
        scene:'',
        mediaTypes:'',
     }];
    // console.log('obj',obj);
    return obj;
}

export function formatDataToSever(form){
    const {ccUIds,sheetTypeIds,toUIds,sample,sampleLog} = form;

    return {
        ...form, 
        ...createccUIdsFromSever({ccUIds}),
        ...createsheetTypeIdsFromSever({sheetTypeIds}),
        ...createtoUIdsFromSever({toUIds}),
        sample: getSampleStrToSever({sample}),
        sampleLog: getSampleLogStrToSever({sampleLog}),
    }
}

// export function formatMainDataToSever(form){
//     const {id,sessionCode,sheetCode,sheetTypeIds,title,content} = form;

//     return {
//         // ...form,
//         id,
//         sessionCode:sessionCode, 
//         sheetCode:sheetCode,
//         ...createsheetTypeIdsFromSever({sheetTypeIds}),
//         title:title,
//         content:content
  
//     }
// }

export function createccUIdsFromSever({ccUIds}){
    return {
        ccUIds:ccUIds.map(item => {            
            // return `<Style styleID="${styleID.includes('新增') ? 0 : styleID}"  supplyno="${supplyno}" size="${size}" price="${price}" remain="${remain}" ></Style>`//1:0.1;2:0.2
            return item[0]
        }).join(',')
    }
}
export function createsheetTypeIdsFromSever({sheetTypeIds}){
    return {
        sheetTypeIds:sheetTypeIds.map(item => {            
            // return `<Style styleID="${styleID.includes('新增') ? 0 : styleID}"  supplyno="${supplyno}" size="${size}" price="${price}" remain="${remain}" ></Style>`//1:0.1;2:0.2
            return item[0]
        }).join(',')
    }
}
export function createtoUIdsFromSever({toUIds}){
    return {
        toUIds:toUIds.map(item => {            
            // return `<Style styleID="${styleID.includes('新增') ? 0 : styleID}"  supplyno="${supplyno}" size="${size}" price="${price}" remain="${remain}" ></Style>`//1:0.1;2:0.2
            return item[0]
        }).join(',')
    }
}

export function createStationXMLDataForSever({stationXmlArray}) {
    return {
        // priceXml: priceXmlArray.map(item => {
        //     const {priceID, dateArray: [sdate = '', edate = ''], length, cnt, price, include = '', except = '', shareArray} = item;
        //     return `<Price priceID="${priceID.includes('新增') ? 0 : priceID}"  sdate="${sdate}" edate="${edate}" length="${length}" cnt="${cnt}" price="${price}" include="${getExceptStrToSever({except: include})}" except="${getExceptStrToSever({except})}" share="${shareArray ? shareArray.filter(item => item.departmentId).map(item => `${item.departmentId}:${item.price}`).join(';') : ''}"></Price>`//1:0.1;2:0.2
        // }).join('')
        detailXml: stationXmlArray.map(item => {
            const {detailId, stationArray,scene,mtArray} = item;
            // return `<Style styleID="${styleID.includes('新增') ? 0 : styleID}"  supplyno="${supplyno}" size="${size}" price="${price}" remain="${remain}" ></Style>`//1:0.1;2:0.2
            return `<Detail detailId="${detailId.includes('新增') ? 0 : detailId}"  stationId="${stationArray[1]}"  scene="${scene}" mediaTypes="${mtArray.join(',')}"></Detail>`//1:0.1;2:0.2
        }).join('')
    };
}


export function getSampleStrToSever({sample}) {
    return sample?.map(item => item.name).join(';') ?? '';
}
export function getSampleLogStrToSever({sampleLog}) {
    return sampleLog?.map(item => item.name).join(';') ?? '';
}

export function getSampleArrayFromSever({sample}) {
    // console.log('sample',sample)
    if (!sample) return [];
    return sample.split(';').filter(item => !!item).map(fileName => {
        return {name: fileName, url: getFileUrl({name: fileName,subDir:''})};
    });
}


export class XMLManager {
    #xmlDocument;

    constructor(xmlStr) {
        this.#parseXMLString({xmlStr});
    }

    #parseXMLString({xmlStr}) {
        const domParser = new DOMParser();
        this.#xmlDocument = domParser.parseFromString(xmlStr, 'text/xml');
        return this.#xmlDocument;
    }

    getXMLElementsByTagName({tagName}) {
        return this.#xmlDocument.getElementsByTagName(tagName);
    }

    getXMLNodeValueByAttributeName({tagName}) {
        return [...this.getXMLElementsByTagName({tagName})].map(element => {
            const obj = {};
            element.getAttributeNames().forEach(attributeName => {
                obj[attributeName] = element.getAttribute(attributeName);
            });
            return obj;
        });
    }
}